/** @module qt.modal
 *  @description 弹窗行为
 */
import { invokeSchema } from '../base';

export enum CommentTypeEnum {
  TEXT = 1,
  VOICE = 10,
  IMAGE = 100,
  TEXT_AND_VOICE = 11,
  TEXT_AND_IMAGE = 101,
}

export enum BindPhoneSourceEnum {
  AUTO_RENEWAL = 'auto_renewal',
  COMMENT = 'comment',
}

/**
 * 上传图片弹窗
 * @example
 * ```
 * qt.modal.uploadImage()
  .then(function (res) {
    console.log(res.url);
  })
  .catch(function (e) {
    console.log(e);
  });
 * ```
 */
export function uploadImage(): Promise<{
  url?: string;
}> {
  return invokeSchema('qingtingfm://action.qingting.fm/selectImageUpload') as Promise<{
    url?: string;
  }>;
}

/** 评论弹窗参数 */
export interface CommentParams {
  /** 被回复者的昵称 */
  replyTo?: string;
  /** 论的topicId */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  topicId?: string | number;
  /** 对于当前节目没有评论的时候需要传programId */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  programId?: string | number;
  /** 如果是一条对于评论的回复， 带上被回复的评论的id */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  commentId?: string | number;
  /** 支持输入的类型，1文字，10语音，100图片，11文字+语音，101文字+图片 */
  type?: CommentTypeEnum;
  /** 默认类型 */
  defaultType?: CommentTypeEnum;
  /** 字数限制 */
  textLimit?: number;
  /** 语音秒数限制 */
  voiceLimit?: number;
}

/** 评论 */
export interface Reply {
  /** 	主题 id */
  topic_id: string;
  /** 用户 id */
  user_id: string;
  /** 评论 id */
  _id: string;
  /** 评论类型 */
  reply_type: number;
  /** 评论用户昵称 */
  user_name: string;
  /** 评论用户头像 */
  user_avatar?: string;
  /** 评论内容 */
  content: string;
}
/**
 * 评论弹窗
 */
export function comment(options: CommentParams): Promise<{ reply: Reply }> {
  const {
    replyTo,
    topicId,
    programId,
    commentId,
    type = 1,
    defaultType = 1,
    textLimit = 300,
    voiceLimit = 300,
  } = options;
  const params: CommentParams = { type, defaultType, textLimit, voiceLimit };
  if (replyTo) params.replyTo = replyTo;
  if (topicId) params.topicId = topicId;
  if (programId) params.programId = programId;
  if (commentId) params.commentId = commentId;
  return invokeSchema('qingtingfm://action.qingting.fm/invokeCommentView', params) as Promise<{ reply: Reply }>;
}

/** 唤起app的绑定手机号弹窗入参 */
export interface BindPhoneParams {
  /** 弹窗文字说明 */
  content?: string;
  /** 来源，auto_renewal  或  comment */
  source: BindPhoneSourceEnum;
}
/** 唤起app的绑定手机号弹窗
 * @example
 * ```javascript
 * qt.modal.bindPhone({content: "请绑手机号", source: 'auto_renewal'})
  .then(function (res) {
    console.log(res.url);
  })
  .catch(function (e) {
    console.log(e);
  });
 * ```
 */
export function bindPhone({ content = '绑定手机号', source }: BindPhoneParams) {
  const params: Partial<BindPhoneParams> = {};
  if (content) params.content = content;
  if (source) params.source = source;
  return invokeSchema('qingtingfm://action.qingting.fm/showBindPhoneDialog', params);
}

export const modal = {
  uploadImage,
  comment,
  bindPhone,
};
